import PageTransition from "@/components/PageTransition";
import Hero from "@/components/Hero";
import ServicesGrid from "@/components/ServicesGrid";
import Manifesto from "@/components/Manifesto";
import YearsSection from "@/components/YearsSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import GalleryGrid from "@/components/GalleryGrid";
import CTABlock from "@/components/CTABlock";

export default function Home() {
  return (
    <PageTransition>
      <Hero />
      <EditorialMarquee />
      <ServicesGrid />
      <Manifesto />
      <YearsSection />
      <GalleryGrid compact />
      <CTABlock />
    </PageTransition>
  );
}
